import React from "react";
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {SourceOfFundsBox} from "./boxes/source-of-funds.box";
import {CyClass} from "../../../common/cy-classes";
import { DialogTextBox } from "../modal-dialog/boxes/text/dialog-text.box";
import { ModalDialogActionsComponent } from "../modal-dialog/modal-dialog-actions.component";

interface SourceOfFundsPopupComponentProps{
    messageRow1:string;
    messageRow2:string;
    openChatLabel:string;
    dialogHandler: IModalDialogHandler;
}

export class SourceOfFundsPopupComponent extends OrbitComponent<SourceOfFundsPopupComponentProps>{

    _closeDialog = () => {
        this.props.dialogHandler.close();
    }

    render(){
        return (
            <SourceOfFundsBox>
                <DialogTextBox>{this.props.messageRow1}</DialogTextBox>
                <DialogTextBox>{this.props.messageRow2}</DialogTextBox>
                <ModalDialogActionsComponent primaryAction={{
                    text: this.props.openChatLabel,
                    onClick: this._closeDialog,
                    className: CyClass('cy-source-of-funds-open-chat-btn')
                }} />
            </SourceOfFundsBox>
        )
    }
}